import styled from 'styled-components'

const StyledRoundView = styled.div`
  height: 100vh;
  width: 100vw;
  overflow: hidden;

  iframe {
    height: 100vh;
    width: 100vw;
    border: 0;
  }

  .guess-modal-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: ${({ theme }) => theme.elevation.fixed};
    
    .guess-modal {
      z-index: ${({ theme }) => theme.elevation.fixed};
      position: relative;
      max-width: 350px;
      border-radius: 10px;
      box-shadow:
        0 1px 1px hsl(0deg 0% 0% / 0.015),
        0 2px 2px hsl(0deg 0% 0% / 0.015),
        0 4px 4px hsl(0deg 0% 0% / 0.015),
        0 8px 8px hsl(0deg 0% 0% / 0.015),
        0 16px 16px hsl(0deg 0% 0% / 0.015)
      ;
      background-color: ${({ theme }) => theme.color.background};
      padding: 20px;
      display: grid;
      grid-gap: 18px;

      .guess-text {
        user-select: none;
        line-height: 22px;
        color: ${({ theme }) => theme.color.gray[600]};

        b {
          user-select: all;
          font-weight: 500;
          color: ${({ theme }) => theme.color.gray[700]};
        }
      }
      
      progress {
        -webkit-appearance: none;
        appearance: none;
        width: 100%;
        height: 20px;

        &::-webkit-progress-bar {
          background-color: ${({ theme }) => theme.color.blue[100]};
          border-radius: 6px;
        }

        ::-webkit-progress-value {
          background-image:
           -webkit-linear-gradient(-45deg, 
              transparent 33%, rgba(255, 255, 255, .15) 33%, 
              rgba(255, 255, 255, .1) 66%, transparent 66%),
           -webkit-linear-gradient(top, 
              rgba(255, 255, 255, .25), 
              rgba(0, 0, 0, .15)),
           -webkit-linear-gradient(left, ${({ theme }) => theme.color.blue[500]}, ${({ theme }) => theme.color.blue[600]});
          box-shadow:
            0 1px 1px hsl(0deg 0% 0% / 0.015),
            0 2px 2px hsl(0deg 0% 0% / 0.015),
            0 4px 4px hsl(0deg 0% 0% / 0.015),
            0 8px 8px hsl(0deg 0% 0% / 0.015),
            0 16px 16px hsl(0deg 0% 0% / 0.015)
          ;
          border-radius: 6px; 
          background-size: 35px 20px, 100% 100%, 100% 100%;
        }
      }

      button {
        box-sizing: border-box;
        background-color: ${({ theme }) => theme.color.blue[600]};
        color: ${({ theme }) => theme.color.background};
        padding: 0 16px 0 14px;
        height: 42px;
        display: flex;
        font-weight: 500;
        border-radius: 6px;
        justify-content: center;
        align-items: center;
        transition: 0.2s;
        user-select: none;
        box-shadow:
          0 1px 1px hsl(0deg 0% 0% / 0.045),
          0 2px 2px hsl(0deg 0% 0% / 0.045),
          0 4px 4px hsl(0deg 0% 0% / 0.045)
        ;
  
        svg {
          height: 20px;
          margin-left: 8px;
        }
  
        &:hover {
          background-color: ${({ theme }) => theme.color.blue[700]};
        }
      }
    }

    .guess-modal-backdrop {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background-color: rgb(0, 0, 0, 0.8);
      backdrop-filter: blur(5px);
    }
  }

  form {
    position: fixed;
    z-index: 1;
    bottom: 10px;
    right: 10px;
    border-radius: 6px;
    display: grid;
    padding: 14px;
    grid-gap: 12px;
    background-color: rgb(0, 0, 0, 0.7);

    .input-container {
      position: relative;

      .dollar-symbol {
        position: absolute;
        pointer-events: none;
        font-size: 14px;
        font-family: ${({ theme }) => theme.type.mono};
        color: rgb(255, 255, 255, 0.6);
        top: 50%;
        transform: translateY(-50%);
        left: 10px;
        padding-right: 10px;
        border-right: 1px solid rgb(255, 255, 255, 0.4);
      }
    }

    button, input {
      height: 38px;
      padding: 0 12px;
      border-radius: 3px;
      width: 240px;
      box-sizing: border-box;
    }

    input {
      background-color: rgb(255, 255, 255, 0.2);
      border: 1px solid rgb(255, 255, 255, 0.2);
      color: rgb(255, 255, 255, 1);
      padding-left: 65px;

      &::placeholder {
        color: rgb(255, 255, 255, 0.6);
      }
    }

    button {
      background-color: ${({ theme }) => theme.color.blue[600]};
      color: ${({ theme }) => theme.color.background};
      font-weight: 600;
    }
  }
`

export default StyledRoundView
